/* eslint-disable react-hooks/exhaustive-deps */
import { FC, memo, useCallback} from 'react'
import { useTranslation } from 'react-i18next'

import { FaTrashAlt } from 'react-icons/fa'

import {
  Button,
  Tooltip,
  useTheme,
} from '@mui/material'

import { IColumn } from 'types'
import { usePUT_removeTeacherFromGroupCourseMutation } from 'redux/api/groupCoursesApi'
import { actionIcon, trashIcon } from 'utils/customizedTheme'

export const useTableModel = () => {

  const { t } = useTranslation()

  const handleGenderFormat = useCallback(
    (cellValue: string) => (cellValue ? t(`common.${cellValue.toLowerCase()}`) : ''),
    [],
  )

  const handleActionsFormat = useCallback(
    (cellValue: string, row: any, index: number) => <Actions row={row} index={index} /> ,
    [],
  )

  const columns: IColumn[] = [
    {
      title: `${t('common.name')}`,
      field: 'full_name',
      order: true,
      width: '25%',
    },
    {
      title: `${t('common.email')}`,
      field: 'email',
      order: true,
      width: '25%',
    },
    {
      title: `${t('common.gender')}`,
      field: 'gender',
      width: '15%',
      order: true,
      format: handleGenderFormat,
    },
    {
      title: `${t('common.subject')}`,
      field: 'subjects',
      order: true,
      width: '25%',
    },
    {
      title: '',
      field: '',
      width: '10%',
      align: 'end',
      order: false,
      format: handleActionsFormat,
    },
  ]

  return columns
}

interface IProps {
  row: any
  index: number
}

const Actions: FC<IProps> = memo(({ row }) => {
  const { t } = useTranslation()
  const theme = useTheme()

  const [unenrollTeacher] = usePUT_removeTeacherFromGroupCourseMutation()
  
  return (
    <>
      {row.actions?.is_deletable && (   
        <Tooltip title={`${t('common.unenroll')}`} arrow placement='top'>
          <Button
            onClick={() => unenrollTeacher({id: row.group_course_id, teacher_id: row.teacher_profile_id})}
            variant='outlined'
            color='error'
            disableElevation
            sx={{ ...actionIcon, ...trashIcon }}
          > 
            <FaTrashAlt />
          </Button>
        </Tooltip>
      )}
    </>
  )
})
